export default __webpack_public_path__ + "static/play-f454d991c575c297aeda281b080a7813.svg";